const config = {
  apiKey: 'AIzaSyDlJh9Y2F7IpayA-HWYlR7ZfvHAB4IUki4',
  authDomain: 'plearngx-login.firebaseapp.com',
  databaseURL: 'https://plearngx-login.firebaseio.com',
  projectId: 'plearngx-login',
  storageBucket: 'plearngx-login.appspot.com',
  messagingSenderId: '597287211402',
  appId: '1:597287211402:web:cfea576ea2f18a5ea8b873'
}

export default config



// WEBPACK FOOTER //
// ./src/firebase/config.js